<template>
  <control-base
    :config="conf"
    :dataType="dataType"
    :parentName="$options.name"
    campaignType="in"
    @property-selected="addProperty"
    @property-removed="removeProperty"
    @loaded="$emit('loaded', $event)"
    ref="base"
  >
    <template v-slot:filters>
      <div class="flex-full">
        <p>Rows per page:</p>
        <select class="browser-default" v-model="conf.rows">
          <option
            v-for="(option, index) in perPage"
            :key="index"
            :value="option"
            :selected="option == conf.rows"
          >
            {{ option === -1 ? "All" : option }}
          </option>
        </select>
      </div>

      <reorder-array
        title="Column Order"
        :values="conf.columns"
        display="label"
        @order-changed="updateOrder"
      />
    </template>
    <template v-slot:control>
      <DataTableDx
          class="table"
          title="Queues"
          table-key="queueNumber"
          :columns="cols"
          :data="queues"
          :page-size="conf.rows"
          @columns-changed="saveCols"
          ref="table"
        />
    </template>
  </control-base>
</template>

<script>
import ArrayStore from "devextreme/data/array_store";
import { DataTableDx } from "@/components"

export default {
  name: "QueueTable",

  components:{
    DataTableDx
  },

  props: {
    config: {
      required: true,
      value: Object,
    },

    shouldResize: {
      required: true,
      value: Boolean,
    },
  },

  watch: {
    shouldResize() {
      this.reactiveShouldResize = this.shouldResize;
      this.$nextTick(() => this.$emit("resized"));
    },
  },

  data() {
    return {
      dataType: "queue",
      perPage: [-1, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50],
      reactiveShouldResize: this.shouldResize,
      oldestCallInQueueInterval: null
    };
  },

  mounted(){
    this.$emit("resized")
    this.registerDependencies();
  },

  computed: {
    conf() {
      return this.config;
    },

    cols() {
      var cols = [...this.conf.columns];
      if (cols.findIndex((x) => x.field == "queueNumber") == -1)
        cols.push({
          label: this.addSpaces("queueNumber"),
          field: this.fieldCase("queueNumber"),
          visible: false,
          width: 0,
          numeric: false,
          html: false,
        });
      return cols;
    },

    queues() {
      if (Object.keys(this.$store.getters.queueData).length == 0) {
        return new ArrayStore({
          key: "queueNumber",
          data: [],
        });
      }
      if(this.cols.findIndex(x=> x.field == "oldestCallInQueue") != -1) this.updateOldestCallQueueingAsync();
      return new ArrayStore({
        key: "queueNumber",
        data: this.$store.getters.queueData.filter((val) => this.conf.campaignNames.includes(val.campaign))
      });
    },
  },

  methods: {
    updateOldestCallQueueingAsync() {
      if (this.oldestCallInQueueInterval)
        clearInterval(this.oldestCallInQueueInterval);
      this.oldestCallInQueueInterval = setInterval(() => {
        var count = this.queues._array.length;
        var arr = this.queues._array;
        for (let i = 0; i < count; i++) {
          var key = arr[i].queueNumber;
          this.queues.push([
            {
              type: "update",
              key: key,
              data: {
                ...arr[i],
                oldestCallInQueue: this.toHHMMSS(
                  Date.now() - new Date(Date.parse(arr[i].oldestCallInQueueDT))
                ),
              },
            },
          ]);
        }
      }, 1000);
    },
    saveCols(data) {
      this.conf.columns = data.map((x) => {
        var index = this.conf.columns.findIndex((z) => z.field == x.field);
        return {
          ...x,
          label: this.conf.columns[index].label,
          color: this.conf.columns[index].color,
        };
      });
      this.$emit("configChange", this.conf);
    },

    updateOrder(cols) {
      this.conf.columns = cols;
      this.$emit("configChange", this.conf);
    },

    addProperty(name) {
      this.conf.columns.push({
        label: this.addSpaces(name),
        field: this.fieldCase(name),
        width: 0,
        numeric: false,
        html: false,
      });
      this.$emit("configChange", this.conf);
    },

    removeProperty(name) {
      var index = this.conf.columns.findIndex(
        (x) => x.field == this.fieldCase(name)
      );
      this.conf.columns.splice(index, 1);
      this.$emit("configChange", this.conf);
    },

    addSpaces(str) {
      return str.replace(/([A-Z])/g, " $1").trim();
    },

    registerDependencies() {
      this.$store.getters.queueArgs.addProperty("QueueNumber");
    },
  },
};
</script>


<style scoped>
.table {
  width: 100%;
  height: 100%;
}

.filters {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 0;
  margin-right: -40px;
  position: absolute;
}
</style>